import { useQuery } from 'react-query';

import {
  enterpriseCodeKey,
  getEnterpriseCodes,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

export const useGetEnterpriseCodes = () => {
  const { data: enterpriseCodesData } = useQuery({
    queryKey: [enterpriseCodeKey],
    queryFn: () =>
      axiosInstance
        .get(getEnterpriseCodes)
        .then((res) =>
          res.data?.object
            ? (Object.values(res.data.object))
            : res?.data,
        ),
  });

  return {
    enterpriseCodesData,
  };
};
